import React from "react";
import { EmptyList, Loading } from "../../../components";
import { ScansFiltersInput } from "../../../__generated__/globalTypes";
import { useScans } from "../hooks";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const ScansPreview = ({ data }) => {
  if (data) {
    // @ts-ignore
    return (
      <Line
        options={{
          responsive: true,
          interaction: {
            mode: "index" as const,
            intersect: false,
          },
          plugins: {
            title: {
              display: true,
              text: `${data?.scans?.results?.[0]?.product?.name}`,
            },
          },
          scales: {
            y: {
              type: "linear" as const,
              display: true,
              position: "left" as const,
              ticks: {
                // Utilisez la fonction callback pour forcer les entiers
                callback: function (value) {
                  if (Number.isInteger(value)) {
                    return value + " pcs";
                  }
                },
              },
            },
            y1: {
              type: "linear" as const,
              display: true,
              position: "right" as const,
              grid: {
                drawOnChartArea: false,
              },
              ticks: {
                // Utilisez la fonction callback pour forcer les entiers
                callback: function (value) {
                  if (Number.isInteger(value)) {
                    return value + " €";
                  }
                },
              },
            },
          },
        }}
        data={{
          labels: data?.scans?.results
            ?.map((scan) => {
              // format  scan.createdAt date to be displayed dd/mm/yyyy hh:mm
              let date = new Date(scan.createdAt);

              // Tableau des jours de la semaine
              const joursSemaine = [
                "dim",
                "lun",
                "mar",
                "mer",
                "jeu",
                "ven",
                "sam",
              ];

              // Récupérer les différentes parties de la date
              let jourSemaine = joursSemaine[date.getDay()]; // jour de la semaine
              let jour = date.getDate().toString().padStart(2, "0"); // jour du mois
              let mois = (date.getMonth() + 1).toString().padStart(2, "0"); // mois, +1 car les mois commencent à 0
              let annee = date.getFullYear(); // année
              let heures = date.getHours().toString().padStart(2, "0"); // heures, avec ajout d'un 0 si nécessaire

              return `${jourSemaine} ${jour}/${mois}`;
            })
            .reverse(),
          datasets: [
            {
              label: "Stocks",
              data: data?.scans?.results
                ?.map((scan) => scan.quantity)
                .reverse(),
              borderColor: "rgb(255, 99, 132)",
              backgroundColor: "rgba(255, 99, 132, 0.5)",
              yAxisID: "y",
            },
            {
              label: "Prix",
              data: data?.scans?.results?.map((scan) => scan.price).reverse(),
              borderColor: "rgb(53, 162, 235)",
              backgroundColor: "rgba(53, 162, 235, 0.5)",
              yAxisID: "y1",
            },
          ],
        }}
      />
    );
  }

  return null;
};
